export const MY_ACCOUNT_TAB_GROUP_ID = 'my-account-tab-group';
